module.exports = __webpack_public_path__ + "static/media/tnc-modal-background.e383e69d.png";